module.exports = __webpack_public_path__ + "static/media/laundry.8caa6c94.jpg";